const actions = {
  FETCH_USERFORM: 'userForm/FETCH_USERFORM',
}

export default actions
